function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import olLayerTile from 'ol/layer/Tile';
import olSourceWMTS, { optionsFromCapabilities } from 'ol/source/WMTS';
import { formatCapabilitiesForOpenLayers } from './CapabilitiesHelper';
import { getZoomLevelHelper } from '../../mapmodule/util/scale';
import { Messaging } from 'oskari-ui/util';
var LayerComposingModel = Oskari.clazz.get('Oskari.mapframework.domain.LayerComposingModel');

/**
 * A Plugin to manage WMTS OpenLayers map layers
 *
 */
Oskari.clazz.define('Oskari.mapframework.wmts.mapmodule.plugin.WmtsLayerPlugin', function () {
  this._log = Oskari.log(this.getName());
  this._capabilities = {};
}, {
  __name: 'WmtsLayerPlugin',
  _clazz: 'Oskari.mapframework.wmts.mapmodule.plugin.WmtsLayerPlugin',
  layertype: 'wmtslayer',
  getLayerTypeSelector: function getLayerTypeSelector() {
    return 'WMTS';
  },
  _initImpl: function _initImpl() {
    // register domain builder
    var mapLayerService = this.getSandbox().getService('Oskari.mapframework.service.MapLayerService');
    if (!mapLayerService) {
      // no map layer service - TODO: signal failure
      return;
    }
    var className = 'Oskari.mapframework.wmts.domain.WmtsLayer';
    var composingModel = new LayerComposingModel([LayerComposingModel.CAPABILITIES, LayerComposingModel.CAPABILITIES_STYLES, LayerComposingModel.CREDENTIALS, LayerComposingModel.GFI_CONTENT, LayerComposingModel.GFI_TYPE, LayerComposingModel.GFI_XSLT, LayerComposingModel.SRS, LayerComposingModel.URL, LayerComposingModel.VERSION], ['1.0.0']);
    mapLayerService.registerLayerModel(this.layertype, className, composingModel);
  },
  _handleDescribeLayerImpl: function _handleDescribeLayerImpl(layer, info) {
    var capabilities = info.capabilities;
    var layerId = layer.getId();
    try {
      this._log.debug("Running WMTS capabilities parsing for layer id: ".concat(layerId), capabilities);
      this._capabilities[layerId] = formatCapabilitiesForOpenLayers(capabilities);
    } catch (err) {
      this._log.warn("Failed to parse capabilities for WMTS layer id: ".concat(layerId), capabilities);
    }
  },
  /**
   * @method _addMapLayerToMap
   * @private
   * Adds a single Wmts layer to this map
   * @param {Oskari.mapframework.domain.WmtsLayer} layer
   * @param {Boolean} keepLayerOnTop
   * @param {Boolean} isBaseMap
   */
  addMapLayerToMap: function addMapLayerToMap(layer, keepLayerOnTop, isBaseMap) {
    if (!this.isLayerSupported(layer)) {
      return;
    }
    var layerId = layer.getId();
    var caps = this._capabilities[layerId];
    if (!caps) {
      Messaging.warn(Oskari.getMsg('MapModule', 'layerUnsupported.unavailable', {
        name: layer.getName()
      }));
      return;
    }
    var mapModule = this.getMapModule();
    var wmtsLayer = this.__createWMTSLayer(layer, caps);
    this._log.debug('created WMTS layer ' + wmtsLayer);
    this._registerLayerEvents(wmtsLayer, layer);
    var zoomLevelHelper = getZoomLevelHelper(mapModule.getScaleArray());
    zoomLevelHelper.setOLZoomLimits(wmtsLayer, layer.getMinScale(), layer.getMaxScale());
    mapModule.addLayer(wmtsLayer, !keepLayerOnTop);
    this.setOLMapLayers(layerId, wmtsLayer);
  },
  __getLayerConfig: function __getLayerConfig(layer) {
    // default params and options
    // URL is tuned serverside so we need to use the one it gives (might be proxy url)
    return _objectSpread({
      name: 'layer_' + layer.getId(),
      style: layer.getCurrentStyle().getName(),
      layer: layer.getLayerName(),
      buffer: 0,
      crossOrigin: layer.getAttributes('crossOrigin')
    }, layer.getOptions());
  },
  __createWMTSLayer: function __createWMTSLayer(layer, caps) {
    var config = this.__getLayerConfig(layer);
    var options = optionsFromCapabilities(caps, config);
    // if requestEncoding is set for layer -> use it since proxied are
    //  always KVP and openlayers defaults to REST
    options.requestEncoding = config.requestEncoding || options.requestEncoding;
    if (!options.urls.length) {
      // force KVP if we have no resource urls/possible misconfig
      options.requestEncoding = 'KVP';
    }
    if (options.requestEncoding === 'KVP') {
      // override url to one provided by server since the layer might be proxied
      options.urls = [layer.getLayerUrl()];
    }
    // attach params to URLs (might contain apikey or other params that aren't passed on capabilities etc)
    options.urls = options.urls.map(function (url) {
      return Oskari.urls.buildUrl(url, layer.getParams());
    });
    // allows layer.options.wrapX to be passed to source.
    // On OL 6.4.3 it's always false from optionsFromCapabilities()
    // On 6.6.1 it appears to be correct and this line could be removed
    options.wrapX = !!config.wrapX;
    var wmtsLayer = new olLayerTile({
      source: new olSourceWMTS(options),
      opacity: layer.getOpacity() / 100.0,
      transparent: true,
      visible: layer.isVisibleOnMap()
    });
    return wmtsLayer;
  },
  /**
   * Adds event listeners to ol-layers
   * @param {OL3 layer} layer
   * @param {Oskari layerconfig} oskariLayer
   *
   */
  _registerLayerEvents: function _registerLayerEvents(layer, oskariLayer) {
    var me = this;
    var source = layer.getSource();
    source.on('tileloadstart', function () {
      me.getMapModule().loadingState(oskariLayer.getId(), true);
    });
    source.on('tileloadend', function () {
      me.getMapModule().loadingState(oskariLayer.getId(), false);
    });
    source.on('tileloaderror', function () {
      me.getMapModule().loadingState(oskariLayer.getId(), null, true);
    });
  },
  /**
   * Called when layer details are updated (for example by the admin functionality)
   * @param {Oskari.mapframework.domain.AbstractLayer} layer new layer details
   */
  _updateLayer: function _updateLayer(layer) {
    if (!this.isLayerSupported(layer)) {
      return;
    }
    var zoomLevelHelper = getZoomLevelHelper(this.getMapModule().getScaleArray());
    var layersImpls = this.getOLMapLayers(layer.getId()) || [];
    layersImpls.forEach(function (olLayer) {
      // Update min max Resolutions
      zoomLevelHelper.setOLZoomLimits(olLayer, layer.getMinScale(), layer.getMaxScale());
    });
  }
}, {
  extend: ['Oskari.mapping.mapmodule.AbstractMapLayerPlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});